<template>
  <div
    class="asc-fleet-my-fleet-wrapper"
    data-automation-id="wrapper_fleet_my_fleet"
  >
    <asc-fleet-my-fleet-grid
      :items="fleetData"
      :loading="loading"
      :is-issue-investigator="isIssueInvestigator"
      :is-issue-reader="isIssueReader"
      :is-issue-updater="isIssueUpdater"
      :on-open-maintenance="onOpenMaintenance"
      :on-open-fde="onOpenFde"
      :on-open-connectivity="onOpenConnectivity"
    ></asc-fleet-my-fleet-grid>
  </div>
</template>

<script>
import AscFleetMyFleetGrid from '../molecules/AscFleetMyFleetGrid.vue'

export default {
  name: 'AscFleetMyFleetWrapper',

  components: {
    AscFleetMyFleetGrid,
  },

  props: {
    fleetData: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isIssueInvestigator: {
      type: Boolean,
      default: false,
    },
    isIssueReader: {
      type: Boolean,
      default: false,
    },
    isIssueUpdater: {
      type: Boolean,
      default: false,
    },
    onOpenMaintenance: {
      type: Function,
      default: () => {},
    },
    onOpenFde: {
      type: Function,
      default: () => {},
    },
    onOpenConnectivity: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
